module.exports = __webpack_public_path__ + "img/Guernsey.36610d9b.png";